import Modal from '../Modal';

const CancelDialog = (props) => {
 return <Modal open={props.open} setOpen={props.setOpen} type={"confirm"} confirmFn={props.confirmFn} text={props.text} title={props.title}/>
}

export default CancelDialog;
